var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"container",class:{active: _vm.show}},[_c('span',[_vm._v("404")]),_c('h1',[_vm._v("Page Not Found")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }